(() => {
  const excluded = 'script,style,textarea,input,select,option,code,pre,[contenteditable="true"]';
  const normalize = text => text.replace(/\bhexagon(?!®)\b/gi, '$&®').replace(/\bniagen(?:®|™)?/gi, 'nicotinamide riboside').replace(/\bchromadex(?:®|™)?/gi, '').replace(/(\d)\s+mg\b/gi, '$1mg');
  const clean = root => {
    if (!root?.isConnected) return;
    if (root.nodeType === Node.TEXT_NODE) {
      if (root.parentElement?.closest(excluded)) return;
      const next = normalize(root.nodeValue);
      if (next !== root.nodeValue) root.nodeValue = next;
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(excluded)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) clean(walker.currentNode);
    [root, ...root.querySelectorAll('[aria-label],[alt],[title]')].forEach(element => {
      if (element.closest(excluded)) return;
      ['aria-label','alt','title'].forEach(attribute => {
        const value = element.getAttribute(attribute);
        if (!value) return;
        const next = normalize(value);
        if (next !== value) element.setAttribute(attribute, next);
      });
    });
    root.querySelectorAll('.hx-product-richtext a[href],a[href*="niagen"],a[href*="chromadex"]').forEach(link => {
      let destination;
      try { destination = new URL(link.href); } catch { return; }
      if (destination.origin === location.origin && destination.pathname === location.pathname && destination.hash) return;
      const label = document.createElement('span');
      label.className = link.className;
      label.append(...link.childNodes);
      link.replaceWith(label);
    });
  };
  const init = () => {
    clean(document.body);
    document.title = normalize(document.title);
    const description = document.querySelector('meta[name="description"]');
    if (description) description.content = normalize(description.content);
    const pending = new Set();
    let frame;
    const observer = new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'characterData') pending.add(record.target);
        else record.addedNodes.forEach(node => pending.add(node));
      });
      if (frame || !pending.size) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        const roots = [...pending];
        pending.clear();
        roots.forEach(clean);
      });
    });
    observer.observe(document.body, {childList:true,subtree:true,characterData:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
